// extracted by mini-css-extract-plugin
export default {"previewContainer":"MediaPreview_previewContainer__c-VXz","preview":"MediaPreview_preview__Fk-jK"};